import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { LoadingProvider } from 'app/components/_shared/loading-spinner/loading-spinner.component';
import { QuestionnaireService } from 'app/services/questionnaire.service';

@Component({
  selector: 'app-questionnaire-complete',
  templateUrl: './questionnaire-complete.component.html',
  styleUrls: ['./questionnaire-complete.component.scss']
})
export class QuestionnaireCompleteComponent implements OnInit {
  static route: string = 'questions/complete';

  locale: any = {};

  paused: boolean;

  constructor(
    private router: Router,
    private localisation: LocalisationService,
    private questionnaireService: QuestionnaireService,
    private loading: LoadingProvider,
    private footerService: Footer
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('QuestionnaireCompleteComponent');
    this.loading.show(this.locale.checkingQuestions, true);
    this.footerService.update(null);

    sessionStorage.setItem('completed', 'true');

    this.questionnaireService.status.subscribe(status => {
      this.paused = status.pause === status.status + 1;
      this.loading.hide();
    });
  }

  seeMyResults() {
    this.router.navigate([`/centigrade/course-areas`]);
  }

  reload() {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/questionnaire-complete/questionnaire-complete.component.ts